var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMytsionOrder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_570_66)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3.20215,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F7A600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0858 8.88866C18.085 8.8878 18.085 8.88609 18.0841 8.88523C18.0824 8.86374 18.0755 8.84225 18.0669 8.82162C18.0643 8.81646 18.0618 8.81217 18.0592 8.80701C18.0557 8.80099 18.0532 8.79498 18.0497 8.78896C18.0428 8.77865 18.0334 8.76919 18.0248 8.7606C18.0222 8.75888 18.0214 8.7563 18.0188 8.75458C18.0033 8.73997 17.9844 8.72965 17.9646 8.7202C17.9596 8.71865 17.9547 8.71663 17.95 8.71418C17.9284 8.70677 17.9058 8.70271 17.883 8.70215H15.9662C15.9396 8.70215 15.9155 8.70817 15.8915 8.71762C15.8846 8.7202 15.8794 8.72364 15.8717 8.72707C15.8554 8.73653 15.8399 8.74684 15.8261 8.75974C15.8236 8.76317 15.8184 8.76489 15.815 8.76833C15.8124 8.77091 15.8115 8.77435 15.8107 8.77693C15.7969 8.79326 15.7866 8.81131 15.778 8.83194C15.7763 8.83537 15.7737 8.83881 15.772 8.84311C15.772 8.84397 15.7711 8.84483 15.7711 8.84569L14.0005 14.6191L12.2291 8.84569C12.2291 8.84483 12.2282 8.84397 12.2282 8.84311C12.2265 8.83881 12.2239 8.83537 12.2222 8.83194C12.2145 8.81207 12.2038 8.79351 12.1904 8.77693C12.1878 8.77435 12.187 8.77091 12.1852 8.76833C12.1818 8.76489 12.1766 8.76317 12.1741 8.75974C12.1603 8.74684 12.1457 8.73567 12.1294 8.72707C12.1225 8.72364 12.1165 8.7202 12.1096 8.71762C12.0855 8.70817 12.0615 8.70215 12.0348 8.70215H10.1181C10.0949 8.70215 10.0734 8.70731 10.0511 8.71418C10.0468 8.7159 10.0416 8.71762 10.0364 8.7202C10.0158 8.72965 9.99776 8.73997 9.98143 8.75458C9.97885 8.75716 9.978 8.75888 9.97628 8.7606C9.96682 8.77005 9.95823 8.77865 9.95049 8.78896C9.94619 8.79498 9.94447 8.80099 9.94104 8.80701C9.93846 8.81217 9.93502 8.81646 9.9333 8.82162C9.92471 8.84225 9.91869 8.86288 9.91525 8.88523C9.91525 8.88609 9.91439 8.8878 9.91439 8.88866L9.1881 17.4804C9.18294 17.5371 9.20271 17.593 9.24053 17.6351C9.27921 17.6764 9.33422 17.7013 9.39009 17.7013H11.1873C11.2922 17.7013 11.379 17.6222 11.3902 17.5174L11.7503 13.8558L13.1384 17.5689C13.1393 17.5698 13.1402 17.5706 13.141 17.5724C13.147 17.5887 13.1556 17.605 13.1659 17.6188L13.1685 17.6214C13.1702 17.6248 13.1745 17.6274 13.1763 17.6299C13.1866 17.6411 13.1969 17.6506 13.2081 17.66L13.2235 17.6703C13.2347 17.6772 13.2467 17.6824 13.2579 17.6875C13.2806 17.6968 13.3048 17.7017 13.3293 17.7021H14.671C14.6899 17.7021 14.7088 17.6987 14.7268 17.6936C14.732 17.6918 14.7371 17.6901 14.7423 17.6875C14.7552 17.6832 14.7664 17.6772 14.7767 17.6703C14.7818 17.6669 14.787 17.6635 14.7913 17.66C14.8033 17.6514 14.8128 17.6411 14.8231 17.6299C14.8257 17.6265 14.8291 17.6239 14.8317 17.6214C14.8317 17.6205 14.8334 17.6196 14.8343 17.6188C14.8446 17.6042 14.8532 17.5887 14.8601 17.5724C14.8601 17.5715 14.8609 17.5706 14.8618 17.5689L16.2499 13.8558L16.6109 17.5182C16.6157 17.5685 16.6391 17.6151 16.6764 17.6491C16.7137 17.6831 16.7624 17.702 16.8129 17.7021H18.6093C18.666 17.7021 18.721 17.6781 18.7588 17.636C18.7975 17.5939 18.8164 17.538 18.8121 17.4813L18.0858 8.88866Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_570_66",
    x: 0.25,
    y: 0.952148,
    width: 27.5,
    height: 27.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.875
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.176471 0 0 0 0 0.2 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_570_66"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_570_66",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMytsionOrder);
export default __webpack_public_path__ + "static/media/mytsionOrder.6129f8c41b0401b8a4f8335387769a18.svg";
export { ForwardRef as ReactComponent };